var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvalanche(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 50",
    style: {
      enableBackground: "new 0 0 120 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#A5A8B6;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#A5A8B6;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000096745422287023299710000008425786254455116467_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.6,21.6h1l2.9,6.7h-1.4l-0.6-1.5h-2.9L38,28.4h-1.3L39.6,21.6z M41.1,25.8l-1-2.7L39,25.8H41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.8,21.6h1.4l1.8,5.1l1.9-5.1h1.3l-2.7,6.7h-1L44.8,21.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.5,21.6h1l2.9,6.7H58l-0.6-1.5h-2.9l-0.6,1.5h-1.3L55.5,21.6z M57,25.8l-1-2.7l-1.1,2.7H57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62,21.6h1.2v5.6h2.9v1.1H62V21.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71,21.6h1l2.9,6.7h-1.4L73,26.8h-2.9l-0.6,1.5h-1.3L71,21.6z M72.6,25.8l-1-2.7l-1.1,2.7H72.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.6,21.6h1.6l3.3,5l0,0v-5h1.2v6.7h-1.5l-3.3-5.2l0,0v5.2h-1.2L77.6,21.6L77.6,21.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.7,23.2c-0.2-0.3-0.5-0.4-0.7-0.5s-0.5-0.1-0.7-0.1c-0.3,0-0.7,0.1-1,0.2s-0.5,0.3-0.7,0.5 s-0.4,0.5-0.5,0.8C88,24.3,88,24.6,88,25s0.1,0.7,0.2,1s0.3,0.6,0.5,0.8c0.2,0.2,0.4,0.4,0.7,0.5c0.3,0.1,0.6,0.2,1,0.2 c0.3,0,0.5-0.1,0.8-0.2s0.5-0.3,0.7-0.6l1,0.7c-0.3,0.4-0.7,0.7-1.1,0.9c-0.4,0.2-0.9,0.3-1.4,0.3s-1-0.1-1.4-0.2 c-0.4-0.2-0.8-0.4-1.1-0.7c-0.3-0.3-0.6-0.7-0.7-1.1c-0.2-0.4-0.3-0.9-0.3-1.4s0.1-1,0.3-1.5c0.2-0.4,0.4-0.8,0.7-1.1 c0.3-0.3,0.7-0.5,1.1-0.7s0.9-0.3,1.4-0.3s0.9,0.1,1.3,0.2c0.4,0.2,0.8,0.4,1.1,0.8L91.7,23.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.4,21.6h1.2v2.7h3.1v-2.7h1.2v6.7h-1.2v-3h-3.1v3h-1.2V21.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.4,21.6h4.4v1.1h-3.3v1.7h3.1v1.1h-3.1v1.8h3.4v1.1h-4.6L104.4,21.6L104.4,21.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.1,25c0,5.3-4.3,9.6-9.6,9.6s-9.6-4.3-9.6-9.6s4.3-9.6,9.6-9.6S33.1,19.7,33.1,25z M20.8,28.8h-1.9 c-0.4,0-0.6,0-0.7-0.1S18,28.5,18,28.3c0-0.1,0.1-0.3,0.3-0.7l4.6-8.1c0.2-0.3,0.3-0.5,0.4-0.6s0.3-0.1,0.4,0s0.2,0.2,0.4,0.6 l1,1.7l0,0l0,0c0.2,0.4,0.3,0.6,0.4,0.8c0.1,0.2,0.1,0.4,0,0.7c0,0.2-0.2,0.4-0.4,0.8l-2.4,4.3l0,0c-0.2,0.4-0.3,0.6-0.5,0.7 c-0.2,0.2-0.4,0.3-0.6,0.3C21.4,28.8,21.2,28.8,20.8,28.8z M25.5,28.8h2.7l0,0c0.4,0,0.6,0,0.7-0.1s0.2-0.2,0.2-0.4 c0-0.1-0.1-0.3-0.3-0.6l0,0l-1.3-2.3l0,0c-0.2-0.3-0.3-0.5-0.4-0.5c-0.1-0.1-0.3-0.1-0.4,0s-0.2,0.2-0.4,0.6L25,27.8l0,0 c-0.2,0.3-0.3,0.5-0.3,0.6c0,0.2,0.1,0.3,0.2,0.4C24.9,28.8,25.1,28.8,25.5,28.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvalanche);
export default __webpack_public_path__ + "static/media/avalanche.8f7218ebf589278f17a12ce195c71aff.svg";
export { ForwardRef as ReactComponent };